import { PROGRESS_STATUS } from '../../consts/enums';

export const style = {
  colors: {
    [PROGRESS_STATUS.COMPLETED]: {
      color: '#FFF',
      backgroundColor: 'success.main',
    },
    [PROGRESS_STATUS.IN_PROGRESS]: {
      color: '#FFF',
      backgroundColor: 'warning.main',
    },
    [PROGRESS_STATUS.ERROR]: {
      color: '#FFF',
      backgroundColor: 'error.main',
    },
    [PROGRESS_STATUS.CANCELLED]: {
      color: '#FFF',
      backgroundColor: '#6B7280',
    },
    [PROGRESS_STATUS.DEGRADED]: {
      color: '#FFF',
      backgroundColor: 'warning.main',
    },
  },
} as const;
